import script from "./PeopleGroupsAdminReportCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleGroupsAdminReportCard.vue?vue&type=script&setup=true&lang=js"

import "./PeopleGroupsAdminReportCard.vue?vue&type=style&index=0&id=20267aa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20267aa0"]])

export default __exports__